<section class="sf-card leads">
  <div class="leads-head">
    <h2 class="section-title"><i class="fa fa-users"></i> Leads<ng-container *ngIf="!loadError"> (Qtd: {{ result?.total }})</ng-container></h2>
    <div class="actions">
      <button class="sf-btn sf-btn--secondary sf-btn--sm" *ngIf="exportLeads" (click)="openExport(modalExport)" data-testid="btn-export-leads">
        <i class="fa fa-download"></i> Exportar Leads
      </button>
      <button class="sf-btn sf-btn--primary sf-btn--sm" (click)="open(modalImportacao)" *ngIf="showImportButton && isUserValidated" data-testid="btn-import-leads">
        <i class="fa fa-upload"></i> Importar Leads
      </button>
    </div>
  </div>

  <form class="filter-bar" (submit)="listPaginated()">
    <div class="search-wrap grow">
      <i class="fa fa-search"></i>
      <input
        type="text"
        name="filter"
        class="form-control"
        [(ngModel)]="filter"
        [disabled]="isLoading"
        placeholder="Pesquisar pelo telefone, nome ou e-mail"
        data-testid="input-search-leads"
      />
      <button type="submit" class="search-go" [disabled]="isLoading" aria-label="Pesquisar"><i class="fa fa-search"></i></button>
    </div>
    <span class="field-hint" *ngIf="isLoading">Pesquisando…</span>
  </form>

  <div class="table-wrap">
    <table class="table">
      <thead>
        <tr>
          <th class="col-name">Nome</th>
          <th class="hidden-sm" style="width: 100px">Telefone</th>
          <th class="hidden-sm">E-mail</th>
          <th class="hidden-sm" style="width: 180px">Dt. Cadastro</th>
          <th></th>
        </tr>
      </thead>
      <!-- O esqueleto vai dentro de uma célula: elemento que não é `<tr>` solto
           no `<tbody>` vira caixa anônima e desalinha a tabela. -->
      <tbody *ngIf="isLoading" data-testid="leads-loading">
        <tr>
          <td colspan="5">
            <app-skeleton variant="table-row" [count]="6" [columns]="5" label="Carregando os leads"></app-skeleton>
          </td>
        </tr>
      </tbody>

      <tbody *ngIf="!isLoading && !loadError && result">
        <tr *ngFor="let lead of result.data">
          <td>
            {{ lead.name }}
            <span class="show-sm">{{ lead.phone }}</span>
            <span class="show-sm">{{ lead.created_at | date : "dd/MM/yyyy, H:mm" }}</span>
          </td>
          <td class="hidden-sm">{{ lead.phone }}</td>
          <td class="hidden-sm">{{ lead.email }}</td>
          <td class="hidden-sm">{{ lead.created_at | date : "dd/MM/yyyy, H:mm" }}</td>
          <td>
            <div class="row-actions">
              <a class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm" ngbTooltip="Chamar no whatsapp" [href]="getWhatsapp(lead)" target="_blank">
                <i class="fa fa-whatsapp wa-ic"></i>
              </a>

              <button
                class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm"
                type="button"
                *ngIf="user?.content_tag_enabled && haveVars(lead)"
                (mouseover)="selectedLead = lead"
                [ngbTooltip]="varsLead"
                placement="left"
              >
                <i class="fa fa-asterisk"></i>
              </button>

              <button
                class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm"
                *ngIf="lead.message_content"
                ngbTooltip="Visualizar texto livre"
                (click)="showLeadText(lead)"
              >
                <i class="fa fa-text-width"></i>
              </button>

              <a class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm" ngbTooltip="Visualizar sequências" [routerLink]="['/lead', lead.id, 'sequences']">
                <i class="fa fa-envelope-o"></i>
              </a>

              <a
                class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm"
                ngbTooltip="Visualizar postback"
                [routerLink]="['/lead', lead.id, 'postback']"
                *ngIf="showPostbackButton && showPostbacks(lead)"
              >
                <i class="fa fa-arrow-circle-right"></i>
              </a>

              <span class="menu-dots" [class.open]="openMenuId === lead.id" *ngIf="hasCopyActions(lead)">
                <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" ngbTooltip="Mais ações" (click)="toggleMenu(lead.id, $event)">
                  <i class="fa fa-ellipsis-v"></i>
                </button>
                <div class="dd" *ngIf="openMenuId === lead.id" (click)="$event.stopPropagation()">
                  <button *ngIf="lead.pix_code" [title]="lead.pix_code" (click)="copy('QRCode do Pix', lead.pix_code); openMenuId = null">
                    <img src="/assets/pix.gif" width="16" /> Copiar QRCode do PIX
                  </button>
                  <button *ngIf="lead.tracking_code" [title]="lead.tracking_code" (click)="copy('Código de rastreio', lead.tracking_code); openMenuId = null">
                    <i class="fa fa-car"></i>
                    <span>Copiar código de rastreio<small class="dd-v">{{ lead.tracking_code }}</small></span>
                  </button>
                  <button *ngIf="lead.tracking_url" [title]="lead.tracking_url" (click)="copy('URL de rastreio', lead.tracking_url); openMenuId = null">
                    <i class="fa fa-external-link-square"></i>
                    <span>Copiar URL de rastreio<small class="dd-v">{{ lead.tracking_url }}</small></span>
                  </button>
                  <button *ngIf="getCheckoutUrl(lead)" [title]="getCheckoutUrl(lead)" (click)="copy('URL do checkout', getCheckoutUrl(lead)); openMenuId = null">
                    <i class="fa fa-file-code-o"></i>
                    <span>Copiar URL do checkout<small class="dd-v">{{ getCheckoutUrl(lead) }}</small></span>
                  </button>
                  <button *ngIf="getTicketUrl(lead)" [title]="getTicketUrl(lead)" (click)="copy('URL do boleto', getTicketUrl(lead)); openMenuId = null">
                    <i class="fa fa-file-o"></i>
                    <span>Copiar URL do boleto<small class="dd-v">{{ getTicketUrl(lead) }}</small></span>
                  </button>
                  <button *ngIf="getPixUrl(lead)" [title]="getPixUrl(lead)" (click)="copy('URL do PIX', getPixUrl(lead)); openMenuId = null">
                    <i class="fa fa-file-o"></i>
                    <span>Copiar URL do PIX<small class="dd-v">{{ getPixUrl(lead) }}</small></span>
                  </button>
                  <button *ngIf="getCustomizedUrl(lead)" [title]="getCustomizedUrl(lead)" (click)="copy('URL customizada', getCustomizedUrl(lead)); openMenuId = null">
                    <i class="fa fa-file-o"></i>
                    <span>Copiar URL customizada<small class="dd-v">{{ getCustomizedUrl(lead) }}</small></span>
                  </button>
                  <button *ngIf="getMembersUrl(lead)" [title]="getMembersUrl(lead)" (click)="copy('URL da página de membros', getMembersUrl(lead)); openMenuId = null">
                    <i class="fa fa-file-o"></i>
                    <span>Copiar URL da página de membros<small class="dd-v">{{ getMembersUrl(lead) }}</small></span>
                  </button>
                </div>
              </span>

              <button class="sf-btn sf-btn--danger sf-btn--icon sf-btn--sm" ngbTooltip="Excluir lead" (click)="confirmDelete(lead)">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="sf-card empty" *ngIf="!isLoading && !loadError && result && result.data.length === 0" data-testid="leads-empty">
    <i class="fa" [class.fa-search]="filter" [class.fa-users]="!filter"></i>
    <p>{{ filter ? 'Nenhum lead encontrado' : 'Nenhum lead cadastrado' }}</p>
  </div>

  <div class="notice notice--danger" *ngIf="!isLoading && loadError">
    <i class="fa fa-exclamation-triangle"></i>
    <div class="notice__body">Não foi possível carregar os leads.</div>
    <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="listPaginated()">
      <i class="fa fa-refresh"></i> Tentar de novo
    </button>
  </div>

  <div class="pg-bar" *ngIf="result && !loadError">
    <app-pagination
      [currentPage]="result.current_page"
      [itemsPerPage]="result.per_page"
      [totalItems]="result.total"
      (pageChanged)="pageChanged($event)"
    >
    </app-pagination>

    <label class="pg-size" *ngIf="!loadError && result.data.length > 0">
      <span>Itens por página</span>
      <select
        class="form-select"
        [ngModel]="perPage"
        (ngModelChange)="changePerPage($event)"
        [disabled]="isLoading"
        aria-label="Itens por página"
        data-testid="select-leads-per-page"
      >
        <option *ngFor="let option of perPageOptions" [ngValue]="option">{{ option }}</option>
      </select>
    </label>
  </div>
</section>

<ng-template #modalImportacao let-modal>
  <div>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title"><i class="fa fa-upload"></i> Importar Contatos</h4>
      <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="modal.dismiss('Cross click')">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="pick-grid pick-grid--2">
        <button type="button" class="pick" [class.on]="fromFile" (click)="fromFile = true" data-testid="input-upload-csv">
          <span class="radio"></span>
          <span class="pk-body"><span class="pk-t">Arquivo (.csv, .txt, .xlsx ou .xls)</span></span>
        </button>
        <button type="button" class="pick" [class.on]="!fromFile" (click)="fromFile = false">
          <span class="radio"></span>
          <span class="pk-body"><span class="pk-t">Campo de Texto</span></span>
        </button>
      </div>

      <app-file *ngIf="fromFile" class="mt-2 mb-2 import-file-zone" [extensionAccepted]="importExtensions" (fileSelected)="changeFile($event)"></app-file>

      <div class="notice notice--sm" data-testid="import-help">
        <i class="fa fa-info-circle"></i>
        <div class="notice__body">
          <span>Envie sua lista como está; usamos só nome, telefone e e-mail. Linhas sem telefone ficam de fora.</span>
          <span *ngIf="fromFile">Colunas em qualquer ordem, com ou sem cabeçalho; as outras colunas são ignoradas. No Excel, lemos a 1ª aba.</span>
          <span *ngIf="!fromFile">Um contato por linha, com os dados separados por ponto e vírgula, vírgula ou tab.</span>
        </div>
      </div>

      <div class="field" *ngIf="!fromFile">
        <label for="leads">Contatos</label>
        <textarea
          name="leads"
          id="leads"
          class="form-control"
          [class.animate__animated]="animateError"
          [class.animate__shakeX]="animateError"
          [class.is-invalid]="importError"
          rows="5"
          placeholder="Cole aqui os contatos, um por linha. Ex.: Maria Silva;11999998888;maria@email.com"
          [(ngModel)]="text"
          data-testid="txt-area-write-leads"
        ></textarea>
      </div>

      <div class="field-grid" style="margin-top: 12px;">
        <div class="field field--wide">
          <app-switcher label="Excluir leads existentes?" [checked]="deleteLeads" (checkedChange)="deleteLeads = !deleteLeads"></app-switcher>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="sf-btn sf-btn--ghost push" (click)="modal.dismiss('Cross click')">Cancelar</button>
      <button type="button" class="sf-btn sf-btn--primary" (click)="import(modal)" data-testid="btn-save-import-leads">
        <i class="fa fa-upload"></i> Importar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modalExport let-modal>
  <div>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-export-title"><i class="fa fa-download"></i> Exportar Leads</h4>
      <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="modal.dismiss('Cross click')">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="pick-grid pick-grid--2">
        <button type="button" class="pick" [class.on]="exportWholeList" (click)="exportWholeList = true" data-testid="input-export-whole-list">
          <span class="radio"></span>
          <span class="pk-body"><span class="pk-t">Lista toda</span></span>
        </button>
        <button type="button" class="pick" [class.on]="!exportWholeList" (click)="exportWholeList = false" data-testid="input-export-by-period">
          <span class="radio"></span>
          <span class="pk-body"><span class="pk-t">Por período</span></span>
        </button>
      </div>

      <div class="field-grid field-grid--2" *ngIf="!exportWholeList" style="margin-top: 16px;">
        <div class="field">
          <mat-form-field>
            <mat-label>Data inicial</mat-label>
            <input matInput [matDatepicker]="exportPickerStart" [(ngModel)]="exportStartDate" data-testid="input-export-start-date" />
            <mat-datepicker-toggle matIconSuffix [for]="exportPickerStart"></mat-datepicker-toggle>
            <mat-datepicker #exportPickerStart panelClass="export-period-picker"></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="field">
          <mat-form-field>
            <mat-label>Data final</mat-label>
            <input matInput [matDatepicker]="exportPickerEnd" [(ngModel)]="exportEndDate" data-testid="input-export-end-date" />
            <mat-datepicker-toggle matIconSuffix [for]="exportPickerEnd"></mat-datepicker-toggle>
            <mat-datepicker #exportPickerEnd panelClass="export-period-picker"></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="field field--wide">
          <small class="field-error" *ngIf="invalidExportPeriod">Período inválido.</small>
          <div class="notice notice--sm">
            <i class="fa fa-info-circle"></i>
            <div class="notice__body">
              Preencha as duas datas para exportar um intervalo, ou apenas uma delas
              para exportar a partir de / até a data informada.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="sf-btn sf-btn--ghost push" (click)="modal.dismiss('Cross click')">Cancelar</button>
      <button type="button" class="sf-btn sf-btn--primary" (click)="export(modal)" [disabled]="invalidExportPeriod" data-testid="btn-confirm-export-leads">
        <i class="fa fa-download"></i> Exportar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modalLeadText let-modalLeadText>
  <div>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title"><i class="fa fa-text-width"></i> Texto livre</h4>
      <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="modalLeadText.dismiss('Cross click')">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="field">
        <label>Texto do lead:</label>
        <div class="msg-bubble">{{ leadText }}</div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="sf-btn sf-btn--primary" (click)="modalLeadText.dismiss()">Fechar</button>
    </div>
  </div>
</ng-template>

<ng-template #varsLead>
  <ng-container *ngIf="user?.content_tag_enabled">
    <p class="title">Variáveis do Lead:</p>
    <p class="attributes">
      <span><b>var1:</b> {{ selectedLead.var1 }}</span><br/>
      <span><b>var2:</b> {{ selectedLead.var2 }}</span><br/>
      <span><b>var3:</b> {{ selectedLead.var3 }}</span><br/>
      <span><b>var4:</b> {{ selectedLead.var4 }}</span><br/>
      <span><b>var5:</b> {{ selectedLead.var5 }}</span><br/>
    </p>
  </ng-container>
</ng-template>
